import { render } from "./Record.vue?vue&type=template&id=7f74645b&scoped=true"
import script from "./Record.vue?vue&type=script&lang=ts"
export * from "./Record.vue?vue&type=script&lang=ts"

import "./Record.vue?vue&type=style&index=0&id=7f74645b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f74645b"

export default script